import React from 'react'
import TrainingBanner from '../Training/TrainingBanner';
import ServiceEquipment from '../service/ServiceEquipment';
import HealthcareFaq from '../../Industries/Healthcare/HealthcareFaq';
import LogisticsFast from './LogisticsFast';
import LogisticsStock from './LogisticsStock';
import TrainingServiceWork from '../Training/TrainingServiceWork';
import InstallationService from '../Installation/InstallationService';
import LogisticsInvest from './LogisticsInvest';

export default function delivery() {
    const Banner = {
        image: "/assets/images/logistics-banner.webp",
        heading: "Your Equipment Reaches You Before Deadlines Slip.",
        description: "A stalled production line doesn't wait for anyone. Supershine ensures equipment reaches your facility through a responsive nationwide network, keeping your operations on schedule and your commitments intact.",
        buttonText: "Request Delivery",
        link: "/contact",
    }


    const TrainingFaq = {
        heading: "Why Facilities Count On Supershine For Equipment",
        image: "/assets/images/keeps-img.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                question: "Decades Of Field Experience",
                answer: "Our team has worked hands-on with industrial laundry equipment across facilities of every scale. That depth means we spot compatibility issues early, recommend the right fit without trial and error, and help you avoid costly mismatches that slow your operations down."
            },
            {
                question: "No More Wrong Equipment",
                answer: "Ordering equipment that doesn't fit your setup wastes time, money, and patience. Supershine's consultation-first approach ensures every piece of equipment is matched to your facility's exact specifications before it ships.",
            },
            {
                question: "Nationwide Equipment Availability",
                answer: "Whether your facility is in a metro city or a tier-2 town, Supershine's distribution network ensures equipment reaches you without unreasonable delays. Wide stock coverage means you're not waiting on back-orders when production is at stake.",
            },
            {
                question: "Single Point Of Contact",
                answer: "One call. One person who knows your facility, your equipment history, and your urgency. No bouncing between departments or repeating yourself to a new rep every time something needs attention.",
            },
        ],

    };

    const faqData = {
        title: "FAQs",
        description:
            "Quick answers to help you get the right equipment to your facility without delays or guesswork.",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "How Do I Find The Right Equipment?",
                answer: "Call or message our team with your machine brand, model number, and a description of the fault. We cross-reference your details against our equipment inventory and confirm the correct match before anything is ordered or dispatched.",
            },
            {
                question: "What If I Don't Know My Model Number?",
                answer: "No problem. Share your machine's brand, type, and a photo of the nameplate if possible. Our team can identify the right equipment based on those details and verify compatibility before shipping.",
            },
            {
                question: "How Fast Can I Get My Equipment?",
                answer: "That depends on your location and stock availability. For most orders, equipment is dispatched the same day once specifications are confirmed, with delivery timelines shared upfront before you commit.",
            },

            {
                question: "Do You Stock Equipment For All Major Brands?",
                answer: "Yes. Supershine maintains inventory across all leading industrial laundry equipment brands. If a specific piece of equipment isn't in stock, our team sources it quickly and keeps you updated at every step.",
            },

            {
                question: "Can You Help Diagnose The Issue Before I Order?",
                answer: "Absolutely. Our team can walk you through basic diagnostics over a call to narrow down the fault, so the equipment you order actually solves the problem instead of adding another trip to the process.",
            }
        ],
    };

    const Service = {
        heading: "How To Get <br> The Right equipment Fast",
        image: "/assets/images/expertis-img.webp",
        alt: "Teenager Smiling",
        faqs: [
            {
                number: "01",
                question: "Provide Equipment Details",
                answer: "Share your machine brand, model number, and serial number so our team can match the correct component without any back and forth or compatibility guesswork.",
            },
            {
                number: "02",
                question: "Explain the Issue",
                answer: "Tell us what stopped working and how the fault presented. The more specific you are, the faster we identify the exact equipment your machine needs.",
            },
            {
                number: "03",
                question: "Confirm Availability & Delivery",
                answer: "We check stock in real time, confirm the part, and arrange dispatch to your facility with a clear delivery timeline before you commit to the order.",
            },
            {
                number: "04",
                question: "Need Installation Support?",
                answer: "If fitting the equipment requires technical assistance, our service team can arrange on-site support so the machine is back in production correctly and quickly.",
            },
        ],

    };

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/delivery",
                name: "Delivery"
            }
        ]
    }

    return (
        <>

            <TrainingBanner data={Banner} breadcrumb={bannerData.breadcrumb} />
            <TrainingServiceWork data={TrainingFaq} />
            <LogisticsFast />
            <ServiceEquipment />
            <LogisticsStock />
            <InstallationService data={Service} />
            <LogisticsInvest />
            <HealthcareFaq data={faqData} />
        </>
    )
}
